import {
  TagGroup,
  TagGroupCreateInput,
  TagGroupUpdateInput
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listTagGroups(): Promise<TagGroup[]> {
  return httpClient.get<TagGroup[]>('/protected/tag-groups');
}

export async function getTagGroup(id: number): Promise<TagGroup> {
  return httpClient.get<TagGroup>(`/protected/tag-groups/${id}`);
}

export async function createTagGroup(data: TagGroupCreateInput): Promise<TagGroup> {
  return httpClient.post<TagGroup, TagGroupCreateInput>('/protected/tag-groups', data);
}

export async function updateTagGroup(id: number, data: TagGroupUpdateInput): Promise<TagGroup> {
  return httpClient.patch<TagGroup, TagGroupUpdateInput>(`/protected/tag-groups/${id}`, data);
}

export async function deleteTagGroup(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/tag-groups/${id}`);
}

export interface TagGroupReorderPayload {
  groupIds: number[];
}

export async function reorderTagGroups(payload: TagGroupReorderPayload): Promise<void> {
  return httpClient.post<void, TagGroupReorderPayload>('/protected/tag-groups/reorder', payload);
}
